import * as React from 'react'
import styled from 'styled-components'
import { FormattedStory } from '@kaminrunde/fireside-utils'

import * as _list from 'theme/organisms'

const list = {
  BrandTeaser: _list.BrandTeaser,
  BrandTeaserList: _list.BrandTeaserList,
  Button: _list.Button,
  Card: _list.Card,
  CartWithImageAndText: _list.CartWithImageAndText,
  Category: _list.Category,
  CategoryHeadlineWithProducts: _list.CategoryHeadlineWithProducts,
  CategoryHeadlineWithSubCategories: _list.CategoryHeadlineWithSubCategories,
  CategoryImageTeaser: _list.CategoryImageTeaser,
  CategoryImageTeaserWithProducts: _list.CategoryImageTeaserWithProducts,
  CategoryImageTeaserWithSubCategories:
    _list.CategoryImageTeaserWithSubCategories,
  CategoryLinkSlider: _list.CategoryLinkSlider,
  ConformityDeclaration: _list.ConformityDeclaration,
  ConformityDeclarationNO: _list.ConformityDeclarationNO,
  Divider: _list.Divider,
  FormBuilder: _list.FormBuilder,
  HeadlineWithProducts: _list.HeadlineWithProducts,
  Image: _list.Image,
  ImageTeaserSingle: _list.ImageTeaserSingle,
  BrandroomImageTeaser: _list.BrandroomImageTeaser,
  Markdown: _list.Markdown,
  MoleculeTest: _list.MoleculeTest,
  PartialTest: _list.PartialTest,
  ProductListing: _list.ProductListing,
  ProductSlider: _list.ProductSlider,
  TeaserSlider: _list.TeaserSlider,
  VideoPlayer: _list.VideoPlayer,
  HeadlineWithSubCategories: _list.HeadlineWithSubCategories,
  ContentTeaserVariants: _list.ContentTeaserVariants,
  DualImageList: _list.DualImageList,
  RaffleRegistrationForm: _list.RaffleRegistrationForm,
  ServiceReviewSlider: _list.ServiceReviewSlider,
  MarkdownAccordion: _list.MarkdownAccordion,
  NewsletterRegistrationForm: _list.NewsletterRegistrationForm,
  SnackableTeaser: _list.SnackableTeaser,
  CardSlider: _list.CardSlider,
  HotspotTeaser: _list.HotspotTeaser,
  HotspotTeaserWithContent: _list.HotspotTeaserWithContent,
  TeaserGrid: _list.TeaserGrid
}

export type TransformedStory = FormattedStory & {
  css: string
  backgrounds?: { css: string; id: string }[]
}

type Props = {
  story: TransformedStory
  cfId: string
  'data-cy-state'?: string
}

export default function Story(props: Props) {
  const css = React.useMemo(() => {
    let css = props.story?.css || ''
    if (props.story?.backgrounds) {
      css += props.story.backgrounds.map((row) => row.css).join('')
    }
    return css
  }, [props.story])

  return (
    <Wrapper className="Story" $css={css} data-em-cfid={props.cfId}>
      {props.story?.backgrounds?.map((row) => (
        <div className={row.id} key={row.id} />
      ))}
      {props.story?.allComponents
        .map((name) => props.story.componentsById[name])
        .filter(Boolean)
        .map((component) => {
          const Component = list[component.name]
          const { gridArea } = component.props

          if (!Component) {
            return (
              <div
                key={gridArea}
                id={component.id}
                className={'story-wrapper ' + gridArea}
              >
                <h3>component &quot;{component.name}&quot; not found</h3>
              </div>
            )
          }

          return (
            <div
              key={gridArea}
              id={'id-' + component.id}
              className={'story-wrapper ' + gridArea}
            >
              <Component {...component.props} />
            </div>
          )
        })}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $css: any }>`
  width: 100%;
  display: grid;

  > .story-wrapper {
    width: 100%;
    > * {
      width: 100%;
      height: 100%;
    }
  }

  ${(props) => props.$css};
`
